import { FormSchema } from 'src/hooks';
import { ChildData } from 'src/models';
import { validatorRules } from 'src/utilities/validator';

export enum RequestAccessorData {
  Checked = 'checked',
  BrandName = 'brandName',
  Number = 'No',
}

export const CheckUsernameResponseCode = {
  USERNAME_AVAILABLE_TO_ADD: '000',
  USERNAME_NOT_AVAILABLE_TO_ADD: '001',
  USERNAME_DOES_NOT_EXIST: '002',
  REACH_MAX_LIMIT_REQUEST: '003',
  ALREADY_REQUEST_TO_CONNECT: '004',
};

export const initialChildData: ChildData = {
  availableBalance: 0,
  availableOverdraft: 0,
  balance: 0,
  bankCode: '',
  bankName: '',
  brandName: '',
  childKybStatus: '',
  childType: '',
  pendingBalance: 0,
  receivingAccount: '',
  receivingAccountName: '',
  receivingBankCode: '',
  relationId: '',
  status: '',
  username: '',
  vaName: '',
  vaNumber: '',
};

export const LABEL = {
  requestColumns: {
    number: 'No.',
    brandName: 'children_childrenStatement_childrenBrandNameColumn',
    action: 'common_action',
  },
  requestCard: {
    manyBrandNames: ' Children',
    title: 'children_listPage_requestToDisconnectCard_title',
  },
  register: {
    header: 'children_listPage_addChild_label',
    brandName: 'children_childrenStatement_childrenBrandNameColumn',
    fullName: 'common_fullName',
    username: 'common_username',
    phoneNumber: 'common_phoneNumber',
    email: 'common_email',
    password: 'common_password',
    register: 'children_listPage_registerChild_label',
    passwordInfo: {
      label: 'The password must have at least',
      data: [
        {
          value: 'common_form_error_oneUppercaseCharacter',
        },
        {
          value: 'common_form_error_oneLowercaseLetter',
        },
        {
          value: 'common_form_error_oneNumber',
        },
        {
          value: '8 characters minimum',
        },
        {
          value: 'common_form_error_oneSpecialCharacter',
        },
      ],
    },
  },
  addChild: {
    header: 'children_listPage_addChild_label',
    superAdminUsername: 'children_listPage_addChild_childrenUsernameLabel',
    add: 'common_add',
  },
  placeholder: {
    brandName: 'children_listPage_registerChild_brandNamePlaceholder',
    vaNumber: 'children_listPage_registerChild_vaNumberPlaceholder',
    vaName: 'children_listPage_registerChild_vaNamePlaceholder',
    fullName: 'children_listPage_registerChild_picFullNamePlaceholder',
    username: 'children_listPage_registerChild_picUsernamePlaceholder',
    phoneNumber: 'children_listPage_registerChild_picPhoneNumberPlaceholder',
    email: 'children_listPage_registerChild_picEmailPlaceholder',
    password: 'children_listPage_registerChild_picPasswordPlaceholder',
    superAdminUsername:
      'children_listPage_addChild_childrenUsernamePlaceholder',
  },
};

export enum AddChildFieldName {
  SuperAdminUsername = 'superAdminUsername',
}

export const ADD_CHILD_SCHEMA: FormSchema = {
  [AddChildFieldName.SuperAdminUsername]: {
    initialValue: '',
    validationRule: 'string',
  },
};

export enum RegisterChildFieldEnum {
  BrandName = 'brandName',
  FullName = 'fullName',
  Username = 'username',
  PhoneNumber = 'phoneNumber',
  Email = 'email',
  Password = 'pass',
}

export const REGISTER_CHILD_SCHEMA: FormSchema = {
  [RegisterChildFieldEnum.BrandName]: {
    initialValue: '',
    validationRule: 'required|string',
  },
  [RegisterChildFieldEnum.FullName]: {
    initialValue: '',
    validationRule: validatorRules.full_name,
  },
  [RegisterChildFieldEnum.Username]: {
    initialValue: '',
    validationRule: validatorRules.username,
  },
  [RegisterChildFieldEnum.PhoneNumber]: {
    initialValue: '',
    validationRule: `required`,
  },
  [RegisterChildFieldEnum.Email]: {
    initialValue: '',
    validationRule: validatorRules.email,
  },
  [RegisterChildFieldEnum.Password]: {
    initialValue: '',
    validationRule: validatorRules.password,
  },
};
